import type { ThreadMessage, ThreadMessageDto } from "app/pages/sales-intelligence/modules/ai-agent/types/thread";

export type CompanyInfo = {
    companyName: string;
    favicon: string;
};

export type Competitor = {
    domain: string;
    favicon?: string;
    companyName?: string;
};

export type UserInfo = {
    domain: string;
    companyName: string;
};

export type AiAgentMeetingContext = {
    goal: string;
    attendees: string;
    competitors: Competitor[];
    isCompanyLevel: boolean;
    otherNotes: string;
    attendeesCount: number;
};

export type AiAgentMeetingPayload = {
    domain: string;
    companyName: string;
    meetingContext: AiAgentMeetingContext;
    calendarAttendees?: string;
};

export type FullThread = {
    domain: string;
    meetingContext: AiAgentMeetingContext;
    messages: ThreadMessage[];
};

export type FullThreadDto = {
    domain: string;
    meetingContext: AiAgentMeetingContext;
    messages: ThreadMessageDto[];
};

export enum ContactSource {
    Salesforce = 1,
    Hubspot = 2,
    Dynamics = 3,
    Similarweb = 4,
}

export type Contact = {
    name: string;
    title?: string;
    email?: string;
    isSelected?: boolean;
    id?: string;
    isSuggested?: boolean;
    // Picked from the contacts API list (suggestions or search), so it keeps its suggestion position.
    isFromContactsList?: boolean;
    source?: ContactSource;
};

export type AiAgentAutocompleteCompany = {
    domain: string;
    companyName: string;
    image?: string;
    isCompanyLevel?: boolean;
};
